import { FC, useEffect, useState, useMemo } from 'react';
import { Project, Competition, CompetitionAPI, API, Book } from "@brg/api";
import { ProjectInPartBlock, ProjectInPartBlockDivider } from "../styles";
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import {Colors, FlexBox, useBreakpoint} from '@brg/ui';
import { ArrowCornerSvg } from 'shared/assets/16/ArrowCornerSvg';
import { getCompetitionTitle } from '_competition/pages/AllCompetitionsPage/helpers/competitionUtils';
import {LayoutConst} from "../../../../core";
import { WinnerCircle } from './PlaceIcon';
import { useGetFriendlyUrlParam } from 'shared/hooks/useGetFriendlyUrlParam';


export const InPartCompetition: FC<{ 
    competitionsWinner: Competition[], 
    competitionsParticipant: Competition[], 
    competitionFynalist: Competition[] 
}> = ({ 
    competitionsWinner, 
    competitionsParticipant, 
    competitionFynalist 
}) => {
    const { t, i18n } = useTranslation();
    const id = useGetFriendlyUrlParam("id");
    const is744BP = useBreakpoint(LayoutConst.screen.s);

    const fynalist = useMemo(() => {
        const competitionsIds = [...competitionsWinner, ...competitionsParticipant]?.map((i) => i?.competitionId)
        return competitionFynalist?.filter((i) => !competitionsIds?.includes(i?.competitionId) )
    } , [competitionsWinner, competitionsParticipant, competitionFynalist])


    if (competitionsWinner.length === 0 && competitionsParticipant.length === 0 && competitionFynalist?.length === 0) {
        return null;
    }

    return (
        <ProjectInPartBlock>
            {competitionsWinner.length > 0 && competitionsWinner.map(x => {
                const hasLink = !!x?.link
                //@ts-ignore
                const temp = x?.nominations?.[0]?.winnerPositions?.find(x => x?.winnerId === id);
                return (<FlexBox direction='row' justify='center' align='center' justifyMobile='start' widthMobile={is744BP ? '100%' : undefined}>
                    <FlexBox className='competition-winner-svg' offsetRight={8} offsetRightMobile={12}>
                        <WinnerCircle  href={hasLink ? x?.link : `${process.env.REACT_APP_URL_HSEDESIGN_RU}/competition/${x.competitionId}`} target={'_BLANK'} rel="noreferrer" place={temp?.position}>{temp?.position}</WinnerCircle>
                    </FlexBox>
                    <FlexBox direction='row' justify='center' align='center' directionMobile='column' justifyMobile='start' alignMobile='start'>
                        <FlexBox className='competition-participant-label' offsetRight={8}>{temp?.position === 1 ? t('competition.winner') : t('competition.prizewinner') }</FlexBox>
                        <a href={hasLink ? x.link : `${process.env.REACT_APP_URL_HSEDESIGN_RU}/competition/${x.competitionId}`} target={'_BLANK'} rel="noreferrer" style={{marginTop: '2px'}}>
                            {getCompetitionTitle(x)}&nbsp;<ArrowCornerSvg clr={Colors.galBlack47} opacity={'1'} />
                        </a>
                    </FlexBox>
                </FlexBox>);
            })}
            {competitionsWinner.length > 0 && competitionsParticipant.length > 0 && (
                <ProjectInPartBlockDivider />
            )}
            {competitionsParticipant.length > 0 && (<FlexBox direction='column' justify='center' align='center' directionMobile='column' justifyMobile='center' alignMobile='center' widthMobile={is744BP ? '100%' : undefined}>
                <FlexBox className='competition-participant-label' offsetBottom={4}>{t(competitionsParticipant.length > 1? 'competition.project_participating_msg_plural' : 'competition.project_participating_msg')}</FlexBox>
                    {competitionsParticipant.map(x => {
                        const hasLink = !!x?.link
                        return (
                            <FlexBox offsetBottom={4}>
                                <a href={hasLink ? x.link : `${process.env.REACT_APP_URL_HSEDESIGN_RU}/competition/${x.competitionId}`} target={'_BLANK'} rel="noreferrer">
                                    {getCompetitionTitle(x)}&nbsp;<ArrowCornerSvg clr={Colors.galBlack47} opacity={'1'} />
                                </a>
                            </FlexBox>);
                    })}
                </FlexBox>)
            }
            {fynalist?.length > 0 && fynalist.map(x => {
                const hasLink = !!x?.link
                return (
                    <FlexBox direction='row' justify='center' align='center' directionMobile='column' justifyMobile='start' alignMobile='start' widthMobile={is744BP ? '100%' : undefined}>
                        <FlexBox className='competition-participant-label' offsetBottom={4} offsetRight={8}>{t('competition.finalist')}</FlexBox>
                        <FlexBox offsetBottom={4}>
                            <a href={hasLink ? x.link : `${process.env.REACT_APP_URL_HSEDESIGN_RU}/competition/${x.competitionId}`} target={'_BLANK'} rel="noreferrer">
                                {getCompetitionTitle(x)}&nbsp;<ArrowCornerSvg clr={Colors.galBlack47} opacity={'1'} />
                            </a>
                        </FlexBox>
                    </FlexBox>);
            })}
        </ProjectInPartBlock>
    )
}import { FC, useEffect, useState, useMemo } from 'react';
import { Project, Competition, CompetitionAPI, API, Book } from "@brg/api";
import { ProjectInPartBlock, ProjectInPartBlockDivider } from "../styles";
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import {Colors, FlexBox, useBreakpoint} from '@brg/ui';
import { ArrowCornerSvg } from 'shared/assets/16/ArrowCornerSvg';
import { getCompetitionTitle } from '_competition/pages/AllCompetitionsPage/helpers/competitionUtils';
import {LayoutConst} from "../../../../core";
import { WinnerCircle } from './PlaceIcon';
import { useGetFriendlyUrlParam } from 'shared/hooks/useGetFriendlyUrlParam';


export const InPartCompetition: FC<{ 
    competitionsWinner: Competition[], 
    competitionsParticipant: Competition[], 
    competitionFynalist: Competition[] 
}> = ({ 
    competitionsWinner, 
    competitionsParticipant, 
    competitionFynalist 
}) => {
    const { t, i18n } = useTranslation();
    const id = useGetFriendlyUrlParam("id");
    const is744BP = useBreakpoint(LayoutConst.screen.s);

    const fynalist = useMemo(() => {
        const competitionsIds = [...competitionsWinner, ...competitionsParticipant]?.map((i) => i?.competitionId)
        return competitionFynalist?.filter((i) => !competitionsIds?.includes(i?.competitionId) )
    } , [competitionsWinner, competitionsParticipant, competitionFynalist])


    if (competitionsWinner.length === 0 && competitionsParticipant.length === 0 && competitionFynalist?.length === 0) {
        return null;
    }

    return (
        <ProjectInPartBlock>
            {competitionsWinner.length > 0 && competitionsWinner.map(x => {
                const hasLink = !!x?.link
                //@ts-ignore
                const temp = x?.nominations?.[0]?.winnerPositions?.find(x => x?.winnerId === id);
                return (<FlexBox direction='row' justify='center' align='center' justifyMobile='start' widthMobile={is744BP ? '100%' : undefined}>
                    <FlexBox className='competition-winner-svg' offsetRight={8} offsetRightMobile={12}>
                        <WinnerCircle  href={hasLink ? x?.link : `${process.env.REACT_APP_URL_HSEDESIGN_RU}/competition/${x.competitionId}`} target={'_BLANK'} rel="noreferrer" place={temp?.position}>{temp?.position}</WinnerCircle>
                    </FlexBox>
                    <FlexBox direction='row' justify='center' align='center' directionMobile='column' justifyMobile='start' alignMobile='start'>
                        <FlexBox className='competition-participant-label' offsetRight={8}>{temp?.position === 1 ? t('competition.winner') : t('competition.prizewinner') }</FlexBox>
                        <a href={hasLink ? x.link : `${process.env.REACT_APP_URL_HSEDESIGN_RU}/competition/${x.competitionId}`} target={'_BLANK'} rel="noreferrer" style={{marginTop: '2px'}}>
                            {getCompetitionTitle(x)}&nbsp;<ArrowCornerSvg clr={Colors.galBlack47} opacity={'1'} />
                        </a>
                    </FlexBox>
                </FlexBox>);
            })}
            {competitionsWinner.length > 0 && competitionsParticipant.length > 0 && (
                <ProjectInPartBlockDivider />
            )}
            {competitionsParticipant.length > 0 && (<FlexBox direction='column' justify='center' align='center' directionMobile='column' justifyMobile='center' alignMobile='center' widthMobile={is744BP ? '100%' : undefined}>
                <FlexBox className='competition-participant-label' offsetBottom={4}>{t(competitionsParticipant.length > 1? 'competition.project_participating_msg_plural' : 'competition.project_participating_msg')}</FlexBox>
                    {competitionsParticipant.map(x => {
                        const hasLink = !!x?.link
                        return (
                            <FlexBox offsetBottom={4}>
                                <a href={hasLink ? x.link : `${process.env.REACT_APP_URL_HSEDESIGN_RU}/competition/${x.competitionId}`} target={'_BLANK'} rel="noreferrer">
                                    {getCompetitionTitle(x)}&nbsp;<ArrowCornerSvg clr={Colors.galBlack47} opacity={'1'} />
                                </a>
                            </FlexBox>);
                    })}
                </FlexBox>)
            }
            {fynalist?.length > 0 && fynalist.map(x => {
                const hasLink = !!x?.link
                return (
                    <FlexBox direction='row' justify='center' align='center' directionMobile='column' justifyMobile='start' alignMobile='start' widthMobile={is744BP ? '100%' : undefined}>
                        <FlexBox className='competition-participant-label' offsetBottom={4} offsetRight={8}>{t('competition.finalist')}</FlexBox>
                        <FlexBox offsetBottom={4}>
                            <a href={hasLink ? x.link : `${process.env.REACT_APP_URL_HSEDESIGN_RU}/competition/${x.competitionId}`} target={'_BLANK'} rel="noreferrer">
                                {getCompetitionTitle(x)}&nbsp;<ArrowCornerSvg clr={Colors.galBlack47} opacity={'1'} />
                            </a>
                        </FlexBox>
                    </FlexBox>);
            })}
        </ProjectInPartBlock>
    )
}